<style lang="stylus">
    .home-body
        width 100%
        background var(--bg-color-tertiary)

        .blank
            width 180px
            height 160px
            background transparent
</style>

<template>
    <div class="home-body">
        <topMenu @setSave="setSave"></topMenu>
        <mainMenu></mainMenu>
        <saveAs v-show="isSave" @setSave="setSave"></saveAs>
    </div>
</template>

<script lang="ts">
    import topMenu from "./topMenu.vue";
    import mainMenu from "./mainMenu.vue";
    import rightMenu from "./rightMenu.vue";
    import saveAs from "./saveAs.vue";
    import { Component, Prop, Watch, Vue } from "vue-property-decorator";
    @Component({
        components: {
            topMenu,
            mainMenu,
            rightMenu,
            saveAs,
        },
    })
    export default class homeBody extends Vue {
        isSave = false;
        setSave(val) {
            this.isSave = val;
        }
        mounted() {
            this.$bus.$on("setSave", () => {
                console.log(1234);
                this.setSave(true);
            });
        }
        beforeDestroy() {
            this.$bus.$off("setSave");
        }
    }
</script>
